import React from "react";
import Image from "next/image";

interface SolutionCardProps {
    number: string;
    title: string;
    features: string[];
    footer: string;
    variant?: "orange" | "teal";
}

const SolutionCard: React.FC<SolutionCardProps> = ({
    number,
    title,
    features,
    footer,
}) => (
    <div className="flex flex-col items-center gap-5 sm:gap-7 text-center h-full">
        <div className="w-17.25 h-17.25 rounded-full flex items-center justify-center font-red-hat text-white text-[40px] leading-13.25 font-light border border-[#FFBC42] bg-[#FC7F16] ">
            {number}
        </div>

        <h3 className="font-medium text-[18px] sm:text-[20px] leading-6 sm:leading-7.5 text-[#1D1D1D] tracking-[0.2px]">
            {title}
        </h3>

        <ul className="text-left w-full">
            {features.map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3">
                    <div className="min-w-1.5 min-h-1.5 max-w-1.5 max-h-1.5 w-1.5 h-1.5 overflow-hidden rounded-full bg-[#1D1D1D] mt-2.5" />
                    <p className="text-[#1D1D1D] font-normal text-[16px] leading-6.5">{feature}</p>
                </li>
            ))}
        </ul>

        <div className="mt-auto bg-[#1B515E] rounded-lg p-2.5 flex items-start gap-2.5 w-full">
            <Image
                src="/assets/icons/check.svg"
                alt="Check"
                width={20}
                height={20}
                className="brightness-0 invert shrink-0 mt-0.5"
            />
            <p className="text-white text-[14px] leading-5 text-left flex-1">{footer}</p>
        </div>
    </div>
);


export default SolutionCard;
